import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  Button,
  IconClose,
  Modal,
  NotificationBanner,
} from 'takeat-design-system-ui-kit';
import api from '~/services/api';
import formatCompleteDate from '~/services/formatDate';
import { format } from 'date-fns';
import { useAuth } from '~/context/AuthContext';
import toast from 'react-hot-toast';
import {
  ClosingCashierTableColumn,
  ClosingCashierTableContainer,
  ClosingCashierTableHeader,
  ClosingCashierTableRow,
} from './styles';
import PinpadTotemModalRow from './PinpadTotemModalRow';

const PinpadTotemModal = (props) => {
  const { pinpadTotemModal, setPinpadTotemModal } = props;
  const { paymentMethodsState } = useAuth();
  const [pinpadTransactions, setPinpadTransactions] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  useEffect(() => {
    if (!pinpadTotemModal) return;
    const getPinpadTransactions = async () => {
      try {
        const response = await api.get('/restaurants/orders/self-service');
        setPinpadTransactions(response.data);
        setPinpadTotemModal(true);
      } catch (e) {
        toast.error(
          'Erro ao buscar transações do totem. Tente novamente mais tarde.'
        );
        console.log('self-service orders error', e);
      }
    };
    getPinpadTransactions();
  }, [pinpadTotemModal]);

  const confirmTotemPinpadPayment = async (
    paymentMethodId,
    sessionId,
    setLoading
  ) => {
    setLoading(true);
    await api
      .post('/restaurants/orders/self-service/pinpad-payment', {
        paymentMethodId,
        sessionId,
      })
      .then((response) => {
        setPinpadTransactions((prev) =>
          prev.map((transaction) => {
            if (transaction.id === response.data.sessionWithBill.id) {
              return {
                ...transaction,
                payments: [
                  {
                    payment_method: {
                      name: response.data.paymentMethod.name,
                    },
                  },
                ],
                status: 'finished',
              };
            }
            return transaction;
          })
        );
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        }
        console.log('sendpinpadpayment error', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const sortedPaymentMethods = paymentMethodsState
      .filter((method) => method.available)
      .sort((a, b) => b.name.localeCompare(a.name))
      .sort((a, b) => (b.is_favorite === true ? 1 : -1));

    const sortedPaymentMethodsFormatted = sortedPaymentMethods.map((method) => {
      return {
        value: method.id,
        label: method.name,
      };
    });
    setPaymentMethods(sortedPaymentMethodsFormatted);
  }, [paymentMethodsState]);

  const getStatusTransaction = (status) => {
    switch (status) {
      case 'paid':
        return 'Pago';
      case 'pending':
        return 'Pendente';
      case 'canceled':
        return 'Cancelado';
      case 'closed':
        return 'Finalizado';
      case 'waiting_payment':
        return 'Aguardando pagamento';
      case 'finished':
        return 'Finalizado';
      default:
        return status;
    }
  };

  return (
    <Modal
      style={{
        maxWidth: 800,
        maxHeight: 764,
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        position: 'relative',
      }}
      open={pinpadTotemModal}
      toggle={() => setPinpadTotemModal(false)}
    >
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <h2
            style={{
              margin: 0,
              fontWeight: 600,
              fontSize: 18,
              lineHeight: '24px',
              color: '#222',
            }}
          >
            Pagamentos via totem
          </h2>
          <IconClose
            fontSize={24}
            style={{ cursor: 'pointer' }}
            onClick={() => setPinpadTotemModal(false)}
          />
        </div>
        <p
          style={{
            margin: 0,
            fontWeight: 500,
            fontSize: 14,
            lineHeight: '20px',
            letterSpacing: 0.1,
            color: '#545454',
          }}
        >
          Para pedidos pendentes de pagamento, selecione o método de pagamento e
          clique em "Pagar".
        </p>
      </div>
      {/* <div>
        <NotificationBanner
          isOpen
          variant="info"
          style={{
            maxWidth: 768,
          }}
        >
          <p
            style={{
              margin: 0,
              fontWeight: 500,
              fontSize: 14,
              lineHeight: '20px',
              letterSpacing: 0.1,
              color: '#545454',
            }}
          />
        </NotificationBanner>
      </div> */}
      <ClosingCashierTableContainer
        style={{
          borderRadius: 8,
          minHeight: 496,
          overflow: 'auto',
          border: '1px solid #f6f6f6',
        }}
      >
        <ClosingCashierTableHeader>
          <ClosingCashierTableColumn>Data e hora</ClosingCashierTableColumn>
          <ClosingCashierTableColumn>Valor</ClosingCashierTableColumn>
          <ClosingCashierTableColumn>Status</ClosingCashierTableColumn>
          <ClosingCashierTableColumn>
            Método de pagamento
          </ClosingCashierTableColumn>
          <ClosingCashierTableColumn
            style={{
              width: 88,
            }}
          />
        </ClosingCashierTableHeader>
        {pinpadTransactions &&
          pinpadTransactions.length > 0 &&
          pinpadTransactions.map((transaction) => (
            <PinpadTotemModalRow
              transaction={transaction}
              confirmPinpadTotemTransaction={confirmTotemPinpadPayment}
              paymentMethods={paymentMethods}
              getStatusTransaction={getStatusTransaction}
              key={transaction.id}
            />
          ))}
      </ClosingCashierTableContainer>
      <div />
    </Modal>
  );
};

export default PinpadTotemModal;
